<template>
  <div class="legal-notice-container">
    <h1>Mentions Légales</h1>

    <p>
      Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la confiance en l'économie numérique, il
      est précisé aux utilisateurs du site <a href="https://tellae.fr">tellae.fr</a> l'identité des différents
      intervenants dans le cadre de sa réalisation et de son suivi.
    </p>

    <h2>1. Édition du site</h2>
    <p>Le présent site, accessible à l’URL <a href="https://tellae.fr">tellae.fr</a>, est édité par :</p>
    <ul>
      <li><strong>Nom de la société:</strong> Tellae</li>
      <li><strong>Forme juridique:</strong> SAS</li>
      <li><strong>Capital social:</strong> 22 857 €</li>
      <li><strong>Siège social:</strong> 1 Rue Jean-Simon Voruz, 44200 Nantes</li>
      <li><strong>Numéro de SIREN:</strong> 885 173 633</li>
      <li><strong>Numéro de TVA intracommunautaire:</strong> FR23885173633</li>
      <li><strong>Responsable de la publication:</strong> Vincent Leblond</li>
      <li><strong>Adresse e-mail:</strong> contact@tellae.fr</li>
    </ul>

    <h2>2. Hébergement du site</h2>
    <ul>
      <li><strong>Nom de l'hébergeur:</strong> OVH</li>
      <li><strong>Adresse de l'hébergeur:</strong> 2 Rue Kellermann, 59100 Roubaix, France</li>
      <li><strong>Adresse e-mail:</strong> support@ovh.net</li>
    </ul>

    <h2>3. Propriété intellectuelle</h2>

    <p>
      L'ensemble de ce site, y compris les textes, les photographies, les logos, les vidéos, les icônes, les sons et les
      logiciels, sont la propriété exclusive de la société Tellae ou de ses partenaires. Toute reproduction,
      représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le
      moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Tellae.
    </p>

    <h2>4. Politique de confidentialité</h2>

    <h3>Responsable du traitement des données</h3>

    <p>Responsable du traitement : Vincent Leblond</p>

    <h3>Données collectées</h3>
    <p>
      La société Tellae s'engage à protéger les données personnelles de ses utilisateurs conformément au Règlement
      Général sur la Protection des Données (RGPD).
    </p>

    <p>
      Nous collectons des données d’identification. Ces données sont collectées lorsque vous remplissez un formulaire de
      contact, créez un compte, vous inscrivez à la newsletter ou lorsque nous entretenons une relation commerciales ou
      partenariale avec vous.
    </p>

    <h3>Finalités du traitement des données</h3>

    <p>
      Nous traitons vos données personnelles pour les finalités suivantes, sur la base des fondements juridiques prévus
      par le RGPD : répondre à vos demandes de contact, exécuter un contrat, améliorer notre site et nos services ou
      envoyer des communications marketing.
    </p>

    <h3>Partage des données</h3>
    <p>
      Vos données personnelles sont destinées à l'usage exclusif de Tellae et ne sont jamais vendues.
    </p>

    <h3>Conservation des données</h3>

    <p>La durée de conservation de vos données est de 5 ans après notre dernier contact.</p>

    <h3>Droits des utilisateurs</h3>
    <p>
      Conformément au RGPD, vous disposez des droits suivants concernant vos données personnelles :
    </p>
    <ul>
      <li><strong>Droit d’accès:</strong> Demander une copie de vos données que nous détenons.</li>
      <li>
        <strong>Droit de rectification:</strong> Demander la correction de vos données si elles sont inexactes ou
        incomplètes.
      </li>
      <li>
        <strong>Droit d’effacement (ou "droit à l’oubli"):</strong> Demander la suppression de vos données, sous
        certaines conditions.
      </li>
      <li>
        <strong>Droit d'opposition:</strong> Vous opposer au traitement de vos données pour des raisons légitimes, ou à
        tout moment pour le marketing direct.
      </li>
      <li>
        <strong>Droit à la limitation du traitement:</strong> Demander la limitation du traitement de vos données.
      </li>
      <li>
        <strong>Droit à la portabilité:</strong> Recevoir les données que vous nous avez fournies dans un format
        structuré et lisible par machine.
      </li>
      Pour exercer ces droits, vous pouvez nous contacter par e-mail à l’adresse : contact@tellae.fr.
    </ul>

    <h3>Réclamation auprès de la CNIL</h3>

    Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez introduire une
    réclamation auprès de la Commission Nationale de l’Informatique et des Libertés (CNIL).

    <h2>5. Cookies</h2>

    <p>
      L’utilisateur est informé que lors de ses visites sur le site, un cookie peut s’installer automatiquement sur son
      logiciel de navigation. Les cookies sont de petits fichiers stockés temporairement sur le disque dur de
      l’ordinateur de l’utilisateur par votre navigateur et qui sont nécessaires à l’utilisation du site
      <a href="https://tellae.fr">tellae.fr</a>.
    </p>
    <p>
      Les cookies ne contiennent pas d’information personnelle et ne peuvent pas être utilisés pour identifier
      quelqu’un. Un cookie contient un identifiant unique, généré aléatoirement et donc anonyme. Certains cookies
      expirent à la fin de la visite de l’utilisateur, d’autres restent. L’information contenue dans les cookies est
      utilisée pour améliorer le site
      <a href="https://tellae.fr">tellae.fr</a>.
    </p>
    <p>
      En naviguant sur le site, L’utilisateur les accepte. L’utilisateur doit toutefois donner son consentement quant à
      l’utilisation de certains cookies. A défaut d’acceptation, l’utilisateur est informé que certaines fonctionnalités
      ou pages risquent de lui être refusées. L’utilisateur pourra désactiver ces cookies par l’intermédiaire des
      paramètres figurant au sein de son logiciel de navigation.
    </p>

    <h2>6. Modification des mentions légales</h2>

    <p>
      Tellae se réserve le droit de modifier cette politique de confidentialité à tout moment. Nous vous encourageons à
      la consulter régulièrement pour prendre connaissance des éventuelles mises à jour.
    </p>
  </div>
</template>

<script>
export default {
  name: "MentionsLegals",
  components: {},
  props: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.legal-notice-container {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  text-align: left;
}

ul {
  list-style-type: none;
  padding: 0;
  margin-bottom: 20px;
}
li {
}
strong {
  font-weight: bold;
}
</style>
